import { render, staticRenderFns } from "./Percepcion.vue?vue&type=template&id=f27fd5ce&scoped=true&"
import script from "./Percepcion.vue?vue&type=script&lang=js&"
export * from "./Percepcion.vue?vue&type=script&lang=js&"
import style0 from "./Percepcion.vue?vue&type=style&index=0&id=f27fd5ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f27fd5ce",
  null
  
)

export default component.exports